define.alias("shared/components/shared/mobile/drawer/image-card", "settings/components/shared/mobile/drawer/image-card");